export const floatToFraction = (value: string, maxDenominator = 10000) => {
  let decimal = parseFloat(value);

  // Handle negative numbers
  const sign = decimal < 0 ? '-' : '';
  decimal = Math.abs(decimal);

  // Handle whole numbers
  if (decimal % 1 === 0) {
    return sign + decimal + '/1';
  }

  // Find the best fraction approximation
  let bestNumerator = 1;
  let bestDenominator = 1;
  let minError = Math.abs(decimal - bestNumerator / bestDenominator);

  for (let denominator = 1; denominator <= maxDenominator; denominator++) {
    let numerator = Math.round(decimal * denominator);
    let error = Math.abs(decimal - numerator / denominator);

    if (error < minError) {
      minError = error;
      bestNumerator = numerator;
      bestDenominator = denominator;

      // Stop if we found an exact match
      if (error === 0) break;
    }
  }

  // Simplify the fraction using GCD
  const gcd = (a: number, b: number): number => (b === 0 ? a : gcd(b, a % b));
  const divisor = gcd(bestNumerator, bestDenominator);

  return sign + bestNumerator / divisor + '/' + bestDenominator / divisor;
};
